import React, { FC } from "react";

import { Controller } from "react-hook-form";

import { SwitchProps } from "./Switch.constant";
import {
  StyledRoundSwitch,
  StyledLabel,
  StyledOuterContainer,
  StyledSwitchContainer,
  StyledDescription,
  StyledTextWrapper,
} from "./Switch.styles";

const Switch: FC<SwitchProps> = ({
  name,
  disabled,
  control,
  isToggle,
  label,
  description,
  onChange,
  justifyContent,
  color,
}) => {
  return (
    <Controller
      control={control}
      defaultValue={isToggle}
      name={name}
      render={({ onChange: onControllerChange, value = false || isToggle }) => (
        <StyledOuterContainer justifyContent={justifyContent}>
          <StyledTextWrapper>
            <StyledLabel> {label}</StyledLabel>
            <StyledDescription> {description}</StyledDescription>
          </StyledTextWrapper>

          <StyledSwitchContainer
            color={color}
            disabled={disabled}
            isToggle={value}
            onClick={() => {
              onControllerChange(!value);

              onChange && onChange(!value);
            }}
          >
            <StyledRoundSwitch isToggle={value} />
          </StyledSwitchContainer>
        </StyledOuterContainer>
      )}
    />
  );
};

export default Switch;
